import React from 'react';
import styled from 'styled-components';

import Layout from 'components/Layout';

import { navigateOut } from 'utils';
import { fitbitPink } from 'themes';
import i18n from 'i18n';

import UpdateIcon from 'icons/update-icon.svg';

const Page = styled.div`
  background: white;
  height: 100%;
  position: relative;
  width: 100vw;
`;

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
`;

const Text = styled.div`
  font-size: 24px;
  margin: 30px 7.5vw;
  width: 85vw;
`;

const GoBack = styled.div`
  width: 100%;
  > a {
    color: ${fitbitPink};
    font-size: 18px;
    letter-spacing: 0;
  }
`;

const Outdated = () => (
  <Layout
    backText={i18n('page.Outdated.backText')()}
    backNavigate={navigateOut}
    pageElement={
      <Page>
        <Container>
          <div>
            <img src={UpdateIcon} alt="Please Update" />
          </div>
          <Text>{i18n('page.Outdated.text')()}</Text>
          <GoBack>
            <button onClick={navigateOut}>Go Back</button>
          </GoBack>
        </Container>
      </Page>
    }
  />
);

export default Outdated;
